import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button} from 'react-bootstrap';
import {getManeuvers} from "../actions/maneuvers";

export class ManeuversPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    // state
    list: PropTypes.array.isRequired,
    error: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    // action
    getManeuvers: PropTypes.func.isRequired,
  };

  async componentDidMount() {
    await this.loadManeuvers();
  }

  loadManeuvers = async() => {
    try {
      await this.props.getManeuvers();
    } catch (err) {
      // nothing to do, error message is in error prop
    }
  };

  addClick = () => {
    this.props.history.push('/maneuvers/add');
  };

  render() {
    const {list} = this.props;
    return <div>
      <h3>ICBC Maneuvers</h3>
      <Button onClick={this.addClick}>Add</Button>
      <table>
        <thead>
        <tr>
          <th>Name</th>
        </tr>
        </thead>
        <tbody>
        {list.map(({maneuverId, name}) => (
          <tr key={maneuverId}>
            <td>{name}</td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>;
  }
}

const mapStateToProps = state => ({
  ...state.maneuvers
});
const mapDispatchToProps = dispatch => bindActionCreators({
  getManeuvers,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ManeuversPage);
